// removed by extract-text-webpack-plugin
module.exports = {"ReviewSection__Comments":"ReviewSection__Comments","reviewSectionComments":"ReviewSection__Comments","ReviewSection__badge__label":"ReviewSection__badge__label","reviewSectionBadgeLabel":"ReviewSection__badge__label","ReviewSection__badge__icon":"ReviewSection__badge__icon","reviewSectionBadgeIcon":"ReviewSection__badge__icon","ReviewSection__h1":"ReviewSection__h1","reviewSectionH1":"ReviewSection__h1","ReviewSection__w1":"ReviewSection__w1","reviewSectionW1":"ReviewSection__w1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContentSection/ReviewSection.scss
// module id = 501
// module chunks = 0